import NoAdvertisersFound from "./NoAdvertisersFound";

export default NoAdvertisersFound;
